import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {

  constructor(public globals: Globals, public router: Router, public translate: TranslateService) { }

  ngOnInit(): void {
  }

  toggle() {
    this.globals.menuOpened = false;
  }

  logout() {
    localStorage.clear();
    localStorage.clear();
    this.globals.loggedIn = false;
    this.router.navigate(['/login'], { replaceUrl: true });
    window.location.reload();
  }
}
